import styled from 'styled-components';

export const RadioWrapper = styled.div<any>`
  ${(props: any) =>
    props.display === 'inline' &&
    `display: inline-block;
    margin-right: 28px;
  `}
  ${(props: any) =>
    props.display === 'column' &&
    `display: flex;
    flex-direction: column;
    margin-bottom: 12px;
  `}
`;

export const Mark = styled.span<{ newUi?: boolean }>`
  display: inline-block;
  position: relative;
  border: 1px solid;
  border-color: ${(newUi) => (newUi ? 'var(--color-indigo-t11)' : '#3a4451')};
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  left: 0;
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: middle;

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: ${(newUi) => (newUi ? 'var(--color-indigo)' : '#670d2d')};
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transition: all 110ms;
  }
`;

export const Input = styled.input<any>`
  position: absolute;
  visibility: hidden;
  display: none;

  &:hover + ${Mark} {
    border-color: ${(props) => (props.newUi ? 'var(--color-indigo-t11)' : '#a0aab7')};

    &::after {
      background-color: ${(props) => (props.newUi ? 'var(--color-indigo)' : '#a46e81')};
    }
  }

  &:checked + ${Mark} {
    &::after {
      width: 14px;
      height: 14px;
      opacity: 1;
      left: 4px;
      top: 4px;
    }
  }

  ${(props: any) =>
    props.disabled &&
    `
    border-color: #607187;
    background: #DFE3E7;

    &:checked + ${Mark} {
      &::after {
      background-color: #607187;
      }
    }

    &:hover + ${Mark} {
      border-color: #607187;

      &::after {
        background-color: #607187;
      }
    }
  `}
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  padding: 5px 10px 5px 0;
  position: relative;
  align-items: center;
  color: #3a4451;
  outline: none;
  ${(props: any) =>
    props.disabled &&
    `
        cursor: not-allowed;
        opacity: 0.4;
    `}
`;
